//#region redux
import { useDispatch } from "react-redux";
//#endregion
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { genericDocumentSentBackSnoozed } from "store/actions/genericDocumentActions";
//#endregion
import useSnoozeAction from "components/common/useSnoozeAction";

function useGenericDocumentSentBackSnoozeAction(id: number, markAsDone: (id: number) => void) {
  const dispatch = useDispatch();

  const onSnoozeSuccess = () => {
    dispatch(genericDocumentSentBackSnoozed(id));
    markAsDone(id);
  };

  const { snoozeAction } = useSnoozeAction(id, WintSuperkollAPIModel.TodoType.GenericVouchersSentBack, onSnoozeSuccess);

  return snoozeAction;
}

export default useGenericDocumentSentBackSnoozeAction;
